import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="mx-auto flex items-center justify-between px-4 md:px-6 h-16">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
          <span className="text-xl font-heading font-bold text-foreground-950 tracking-tight">
            最新发布页
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-6">
          <Link
            to="/"
            className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
              location.pathname === '/'
                ? 'text-primary-600'
                : 'text-foreground-700 hover:text-foreground-950'
            }`}
          >
            首页
          </Link>
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                location.pathname === `/category/${cat.slug}`
                  ? 'text-primary-600'
                  : 'text-foreground-700 hover:text-foreground-950'
              }`}
            >
              {cat.name}
            </Link>
          ))}
          <Link
            to="/about"
            className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
              location.pathname === '/about'
                ? 'text-primary-600'
                : 'text-foreground-700 hover:text-foreground-950'
            }`}
          >
            关于我们
          </Link>
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer text-foreground-700"
          aria-label="切换菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/70 px-4 pb-4 pt-2">
          <div className="flex flex-col gap-3">
            <Link
              to="/"
              className={`text-sm font-medium py-2 transition-colors cursor-pointer ${
                location.pathname === '/' ? 'text-primary-600' : 'text-foreground-700'
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`text-sm font-medium py-2 transition-colors cursor-pointer ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'text-primary-600'
                    : 'text-foreground-700'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`text-sm font-medium py-2 transition-colors cursor-pointer ${
                location.pathname === '/about' ? 'text-primary-600' : 'text-foreground-700'
              }`}
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}